import Main from '@components/main';
import { fetchUserInfo } from '@containers/my-info/queries';
import { myInfoSelector, setMyInfo } from '@stores/myInfo';
import { SocketProvider } from 'context/socket';
import { useSession } from 'next-auth/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Noto_Sans_KR,
  Noto_Sans_Thai,
  Noto_Sans,
  Prompt,
  Poppins,
} from 'next/font/google';
import clsx from 'clsx';

export const prompt = Prompt({
  subsets: ['thai', 'latin'],
  weight: ['400', '500', '700'],
  variable: '--font-prompt',
  display: 'swap',
});

export const notoSansKr = Noto_Sans_KR({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
  variable: '--font-noto-kr',
  display: 'swap',
});

export const poppins = Poppins({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
  variable: '--font-poppins',
  display: 'swap',
});
export default function Layout({ children }: { children: React.ReactNode }) {
  const dispatch = useDispatch();
  const { data } = fetchUserInfo();
  const myInfo = useSelector(myInfoSelector);
  const { status } = useSession();

  const storeMyInfo = async () => {
    if (status !== 'authenticated') return;
    if (data) {
      dispatch(setMyInfo(data));
    }
  };

  useEffect(() => {
    storeMyInfo();
  }, [data]);

  return (
    <>
      {myInfo && (
        <SocketProvider>
          <div
            className={`${prompt.variable} ${notoSansKr.variable} ${poppins.variable}`}
          >
            <Main>{children}</Main>
          </div>
        </SocketProvider>
      )}
    </>
  );
}
